<template>
    <div class="comp-media-pop layout1" :class="{'showInner': showPop}" v-if="visible" ref="mediaPop">
        <div class="comp-media-pop_outer">
            <div class="comp-media-pop_header">
                <div class="left">
                    <i class="iconfont icon-v3 back" @click="close"></i>
                    <!-- tab -->
                    <div class="inner-tab">
                        <template v-for="(item, index) in tabs">
                            <p
                                v-if="showCurrentTab(item)"
                                :key="'tab-' + item.name"
                                :class="{ active: selectedTab === item.value }"
                                @click="tabClick(item, index)"
                            >
                                {{ item.name }}
                            </p>
                        </template>
                    </div>
                </div>
                <div class="operator">
                    <i
                        v-if="!sold"
                        @click="onFavoriteClick"
                        class="iconfont"
                        :class="[
                            hasFavor && !!user
                                ? 'icon-favorite_02'
                                : 'icon-favorite_01'
                        ]"
                    ></i>
                    <i
                        class="iconfont icon-share2"
                        @click="handleShare"
                    ></i>
                </div>
            </div>
            <div class="comp-media-pop_content" v-if="selectedTab === 'imgs'">
                <template v-for="(item, index) in source.imgs">
                    <img-box
                        :key="index + 'img'"
                        v-if="['img'].includes(item.type)"
                        :src="item.preview"
                        :lazy="true"
                        alt
                        @click="streamToInner(item, index)"
                        :class="{active: imgIndex === index}"
                    />
                </template>
            </div>
            <div class="comp-media-pop_content" v-else>
                <div class="video-container" v-for="(item, index) in source[selectedTab]" :key="index">
                    <div
                        class="video-content"
                    >
                        <video
                            v-if="canPlayWithVideo(item.url)"
                            :src="item.url"
                            controls="controls"
                        ></video>
                        <iframe
                            v-else
                            :style="iframeStyle"
                            frameborder="no"
                            :src="formatUrl(item.url)"
                            rel="nofollow"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="com-media-pop_inner" v-if="showPop">
            <!-- content -->
            <div class="inner-content">
                <Swiper
                    :key="index"
                    v-if="selectedTab === 'imgs' && source.imgs.length > 0"
                    @slideChange="slideChange"
                    @afterInit="onSwiperInit"
                >
                    <Slide
                        v-for="(item, idx) in allImgs"
                        :key="
                            idx
                                +
                                'slide'"
                    >
                        <site-img
                            v-if="item.type === 'img'"
                            :src="item.preview"
                            dir="width"
                            ref="siteImg"
                        />
                    </Slide>
                    <div class="pic-nums" v-if="selectedTab === 'imgs'">
                        {{ imgIndex + 1 }}/{{ allImgs.length }}
                    </div>
                    <div class="inner-status" @click="closeInnerPop">
                        <i class="iconfont icon-close-light"></i>
                    </div>
                </Swiper>
            </div>
        </div>
        <template v-if="!showPop">
            <BottomMenu
                v-if="!sold"
                :theme="theme"
                :isOffer="isOffer"
                :scroll="false"
            />
        </template>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import util from '@/common/util';
import BottomMenu from './layout1/components/bottom-menu.vue';
import { Swiper, SwiperSlide } from '@/common/swiper';
import API from './api.js';

function getMatterPort(links = [], type = '3d') {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type,
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            visible: false,
            showPop: false,
            imgIndex: 0,
            DEFAULT_IMAGE:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            source: {
                imgs: [],
                virtuals: [],
                videos: []
            },
            selectedTab: 'imgs'
        };
    },
    components: {
        BottomMenu,
        Swiper,
        Slide: SwiperSlide
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page || {}
        }),
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        ...mapState({
            'hasFavor': 'hasFavor'
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        tabs() {
            return [
                { name: this.$t('md-detail-info.photos'), value: 'imgs' },
                {
                    name: this.$t('md-detail-info.virtualTour'),
                    value: 'virtuals'
                },
                { name: this.$t('md-detail-info.videoTour'), value: 'videos' }
            ];
        },
        allImgs() {
            return this.source?.imgs?.filter(v => v.type === 'img') || [];
        },
        info() {
            return this.listingDetail.info || {};
        },
        iframeStyle() {
            return 'width: 100%; height: 360px';
        },
        isOffer() {
            return ['broker', 'standard'].includes(this.theme);
        }
    },
    props: {
        onFavoriteClick: {
            type: Function,
            default: () => {}
        },
        sharePop: {
            type: Function,
            default: () => {}
        },
        schedulePop: {
            type: Function,
            default: () => {}
        },
        listingDetail: {
            type: Object,
            required: true
        },
        sold: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'classic'
        }
    },
    provide() {
        return {
            onFavoriteClick: this.onFavoriteClick,
            theme: this.theme,
            sharePop: this.sharePop,
            schedulePop: this.schedulePop
        };
    },
    created() {
        this.initMediaData();
    },
    beforeMount() {
        this.fingerPs = Promise.all([
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/AlloyFinger.js'
            ),
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/transform.js'
            )
        ]);
    },
    methods: {
        onSwiperInit(swiper) {
            if (this.selectedTab === 'imgs') {
                setTimeout(() => {
                    swiper.slideTo(this.imgIndex)
                })
            }
        },
        slideChange(swiper) {
            if (this.selectedTab === 'imgs') {
                this.imgIndex = swiper.realIndex;
                this.resetAllImg();
            }
        },
        async tabClick(item, index) {
            if (index > 0) {
                // https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0
                const url = this.source[item.value]?.[0]?.url;
                if (url) {
                    const res = await API.getCanXFrame.call(this, url);
                    if (!res?.data?.canXFrame) {
                        window.open(url, '_blank');
                        return;
                    }
                }
            }
            this.selectedTab = item.value;
        },
        /**
         * type
         * photo -> img
         * virtuals -> 3d,virtualTour
         * videos-> video
         */
        initMediaData() {
            let listingPictures = !this.info.listingPictures
                ? []
                : this.info.listingPictures.split('|').filter(item => !!item);
            this.source.imgs = listingPictures.map(url => {
                return {
                    preview: url,
                    type: 'img',
                    url
                };
            });

            let { link, chimeVideoLink } = this.info;
            let virtualLinks = link ? link.trim().split(' ') : [],
                videoLinks = chimeVideoLink
                    ? chimeVideoLink.trim().split(' ')
                    : [];
            const res = [
                getMatterPort(virtualLinks),
                getMatterPort(videoLinks)
            ];
            const bothHasMatterport = res.every(v => !!v);
            const inVirtual = !!res[0];
            const inVideo = !!res[1];
            // matterport Classified as virtual tour  Put it in the picture dripping two
            let matterport = getMatterPort([...virtualLinks, ...videoLinks]);
            if (matterport) {
                const url = matterport.url;
                //  from links kick out matterport
                virtualLinks = virtualLinks.filter(link => link != url);
                if (!bothHasMatterport) {
                    videoLinks = videoLinks.filter(link => link != url);
                }

                if (bothHasMatterport) {
                    matterport.from = 'virtual';
                    this.source.virtuals.push(matterport);
                } else {
                    if (inVirtual) {
                        matterport.from = 'virtual';
                        this.source.virtuals.unshift(matterport);
                    } else if (inVideo) {
                        matterport.from = 'video';
                        this.source.videos.unshift(matterport);
                    }
                }

                // matterport The preview image is placed second
                // this.source.imgs =
                //     this.source.imgs.length > 2
                //         ? [
                //             ...this.source.imgs.slice(0, 1),
                //             matterport,
                //             ...this.source.imgs.slice(1)
                //         ]
                //         : [...this.source.imgs, matterport];
            }

            // virtual tour remove matterport Everything except is placed after the image stream preview
            let placeImageIndex = 0;
            if (virtualLinks.length > 0) {
                const virtuals = virtualLinks.map(v => {
                    return {
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'virtualTour',
                        url: v
                    };
                });
                this.source.virtuals.push(...virtuals);
                this.source.imgs.push(...virtuals);
            }

            // video  put at the end of the picture stream
            if (videoLinks.length > 0) {
                this.source.videos = videoLinks.map((url, index) => {
                    return {
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'video',
                        url
                    };
                });

                this.source.imgs.push(...this.source.videos);
            }

            if (this.source.imgs.length === 0) {
                this.source.imgs.push({
                    preview: this.DEFAULT_IMAGE,
                    type: 'img'
                });
            }
        },
        showCurrentTab(tab) {
            return tab.type === 'imgs'
                ? this.allImgs.length
                : this.source[tab.value].length;
        },
        async streamToInner(item, index) {
            const { type, url } = item;
            // const url = `https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0`;
            if (url && type && type !== 'img') {
                const res = await API.getCanXFrame.call(this, url);
                if (!res?.data?.canXFrame) {
                    window.open(url, '_blank');
                    return;
                }
            }
            if (type == 'img') {
                this.showInner(type, index);
            }
        },
        showInner(type, index, from = undefined) {
            if (type === 'img') {
                let count = this.source.imgs
                    .slice(0, index)
                    .filter(v => v.type != 'img').length;
                index = index - count;
                this.imgIndex = index;
                this.showPop = true;
                this.selectedTab = 'imgs';
                setTimeout(() => {
                    this.bindPinchEvent();
                });
            }
        },
        handleShare() {
            this?.sharePop();
        },
        formatUrl(url) {
            const res = this.parseYoutube(url);
            if (res.overwrite) {
                return res.url;
            } else {
                return url;
            }
        },
        parseYoutube(url) {
            /*https://youtu.be/Ounzu9U8NNc
            https://youtu.be/Ounzu9U8NNc?t=19
            https://www.youtube.com/watch?v=Ounzu9U8NNc
             converted to https://www.youtube.com/embed/Ounzu9U8NNc
            */
            let hash;
            try {
                let regs = [
                    /http?s:\/\/youtu.be\/([^?/]*)/,
                    /http?s:\/\/www.youtube.com\/watch\?v=([^?/]*)/
                ];

                let matches = regs.map(reg => url.match(reg));
                matches = matches.filter(match => match?.length === 2);
                hash = matches[0][1] || '';
            } catch (error) {
                return { overwrite: false, url };
            }

            if (!hash) {
                return { overwrite: false, url }; 
            }
            return {
                overwrite: true,
                url: `https://www.youtube.com/embed/${hash}`
            };
        },

        canPlayWithVideo(url) {
            return /^.*.mp4|.webm|.ogg$/i.test(url);
        },
        _openMediaPop(index = 0) {
            let virtuals = this.source.virtuals || [];
            let videos = this.source.videos || [];
            let _index = index;
            if (videos.length > 0 && virtuals.length > 0) {
                _index -= 2
            } else if (videos.length > 0 || virtuals.length > 0) {
                _index -= 1
            }
            _index = _index <= 0 ? 0 : _index;
            this.visible = true;
            this.imgIndex = _index;
            this.$nextTick(() => {
                const mediaPop = this.$refs?.mediaPop;
                const el =
                    mediaPop && mediaPop.querySelectorAll('.img-box')[_index];
                _index &&
                    el &&
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start'
                    });
            });
        },
        _openVirtualTourPop() {
            this.visible = true;
            this.fingerPs.then(() => {
                this.selectedTab = 'virtuals';
            });
        },
        _openVideoPop() {
            this.visible = true;
            this.fingerPs.then(() => {
                this.selectedTab = 'videos';
            });
        },
        _openImgPop(index = 0) {
            this.visible = true;
            this.fingerPs.then(() => {
                this.imgIndex = index;
                this.selectedTab = 'imgs';
            });
        },
        _getSource() {
            return util.deepClone(this.source);
        },
        closeInnerPop() {
            this.showPop = false;
        },
        bindPinchEvent() {
            let imgs = this.$refs?.siteImg;
            this.fingerPs.then(() => {
                const AlloyFinger = window?.AlloyFinger;
                imgs.length &&
                    Array.from(imgs).map(img => {
                        img = img.$el;
                        window?.Transform(img);
                        img.setAttribute(
                            'data-inittransform',
                            img.style.transform
                        );
                        let initScale = 1;
                        new AlloyFinger(img, {
                            // pressMove: function (evt) {
                            //     if (img.scaleX == 1) return;
                            //     img.translateX += evt.deltaX;
                            //     img.translateY += evt.deltaY;
                            //     evt.preventDefault();
                            // },
                            multipointStart: function() {
                                initScale = img.scaleX;
                            },
                            pinch: function(evt) {
                                const scale = initScale * evt.zoom;
                                img.scaleX = img.scaleY = scale < 1 ? 1 : scale;
                            }
                        });
                    });
            });
        },
        resetAllImg() {
            let imgs = this.$refs?.siteImg;
            imgs?.length &&
                Array.from(imgs).map(img => {
                    img = img.$el;
                    img.style.transform =
                        img.getAttribute('data-inittransform');
                });
        },
        getElScale(el) {
            return +el.style?.transform?.match(/scale\((.*)\)/)[1] || 1.0;
        },
        removePinchEvent() {
            const Hammer = window?.Hammer;
            Hammer && Hammer.Manager.destroy();
        },
        close() {
            this.visible = false;
        }
    },
    watch: {
        visible: function(newval) {
            if (!newval) {
                this.display &&  this.display(false)
            } 
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
.comp-media-pop.layout1 {
    position: fixed;
    z-index: var(--level-subhigh);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    overflow: hidden;
    &.showInner {
        z-index: calc(var(--level-subhigh) + 2);
    }

    .iconfont {
        font-size: 16px;
        cursor: pointer;
    }
    .operator {
        .icon-favorite_02 {
            color: #f0454c;
        }
    }
    .comp-media-pop_outer {
        height: 100%;

        .comp-media-pop_header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1;
            background: #fff;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 15px;
            .left {
                display: flex;
                height: 100%;
                align-items: center;
                .back {
                    font-size: 16px;
                    margin-right: 10px;
                    padding: 0;
                }
                .inner-tab {
                    display: flex;
                    gap: 20px;
                    height: 100%;
                    align-items: center;
                    p {
                        font-size: 12px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        color: var(--g-primary-color);
                        &.active {
                            font-family: var(--font-medium);
                            color: var(--color-theme);
                            border-bottom: 2px solid var(--color-theme);
                        }
                    }
                }
            }
            .operator {
                display: flex;
                align-items: center;
                gap: 15px;
                .iconfont {
                    font-size: 16px;
                    padding: 5px;
                }
            }
        }
        .comp-media-pop_content {
            padding: 50px 0;
            width: 100%;
            height: 100%;
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
            .img-box {
                width: 100%;
                height: 224px;
                margin-bottom: 2px;
                .loading-box {
                    background-color: transparent;
                }
                &:last-child {
                    margin-bottom: 0;
                }
                img {
                    object-fit: cover;
                }
                &.active {
                    border: solid 3px var(--mg-button-background);
                }
            }
            .video-preview {
                margin-bottom: 5px;
                &.active {
                    border: solid 3px var(--mg-button-background);
                }
            }
            .video-container {
                width: 100%;
                height: 100%;
                .video-content {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .com-media-pop_inner {
        height: 100%;
        width: 100%;
        background: rgba(25,25,25, 0.9);
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        z-index: var(--level-subhigh);
        .inner-tab {
            display: flex;
            padding: 6px 15px 0px;
            border-bottom: 1px solid #363636;
            p {
                padding: 10px 15px;
                color: #fff;
                cursor: pointer;
                &.active {
                    color: var(--color-theme);
                    border-bottom: 2px solid var(--color-theme);
                }
            }
        }
        .inner-status, .pic-nums {
            padding: 0 15px;
            display: flex;
            justify-content: center;
            position: absolute;
            top: auto;
            bottom: 30px;
            z-index: 1;
            width: 100%;
            .iconfont {
                color: #fff;
                &.icon-close-light {
                    font-size: 24px;
                }
            }
        }
        .pic-nums {
            font-size: 16px;
            line-height: 1.5;
            color: #fff;
            bottom: 236px;
        }
        .inner-content {
            flex: 1;
            display: flex;
            padding: 0;
            flex-direction: column;
            justify-content: center;
            position: relative;
            z-index: 0;
            .swiper-container {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                    transition: 0.3 all ease;
                }
                .video-content {
                    width: 100%;
                    video {
                        width: 100%;
                        height: 100%;
                    }
                }
                .slide-content {
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
            }
        }
    }
    .video-preview {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        img {
            width: 100%;
            max-height: 40%;
            object-fit: cover;
            filter: brightness(0.9) blur(2px);
        }
        .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 67px;
            height: 67px;
            border-radius: 50%;
            background: #fff;
            text-align: center;
            line-height: 67px;
            .iconfont {
                font-size: 24px;
                transform: rotate(-90deg);
                display: inline-block;
                margin-left: 4px;
            }
        }
    }
    .swiper {
        width: 100%;
        height: 100%;
        .swiper-slide {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        img {
            width: 100%;
        }
    }
}
</style>
